export default __webpack_public_path__ + "b70f6d6342683425dbdcb762b44122f4.svg";